<template>
<div class="page_hezuo_zj">
    <div class="list clearfix">
        <div class="item seller f-l" v-if="applySeller!=1" @click="goPage(applySeller!=3?'/cooperation/applying':'/cooperation/seller',2,applySeller)">
            <div class="">申请成为</div>
            <div class="">供应商</div>
        </div>
        <div class="item trades f-l" v-if="applyTradesman!=1" @click="goPage(applyTradesman!=3?'/cooperation/applying':'/cooperation/tradesman',1,applyTradesman)">
            <div class="">申请成为</div>
            <div class="">匠人</div>
        </div>
        <div class="item agent f-l" v-if="applyAgent!=1" @click="goPage(applyAgent!=3?'/cooperation/applying':'/cooperation/agent',3,applyAgent)">
            <div class="">申请成为</div>
            <div class="">分销商</div>
        </div>
        <div class="item partner f-l" v-if="applyPartner!=1" @click="goPage(applyPartner!=3?'/cooperation/applying':'/cooperation/partner',4,applyPartner)">
            <div class="">申请成为</div>
            <div class="">城市合伙人</div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import {
    Uploader
} from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: '',
            applyTradesman: false,
            applySeller: false,
            applyAgent: false,
			applyPartner: false
        };
    },
    created: function () {
        
    },
    mounted: function () {
		// 移除 缓存中供应商、匠人、代理商、合伙人审核状态
		localStorage.removeItem('seller_apply_status')
		localStorage.removeItem('agent_apply_status')
		localStorage.removeItem('tradesman_apply_status')
		localStorage.removeItem('partner_apply_status')
		// 
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '申请合作',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getApplyStatus()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '申请合作',
                        detail: '诚邀匠人免费入驻，资源共享，合作共赢。\n这里也许会成为你独一无二的展示平台和空间……',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'hezuo.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token
            this.getApplyStatus()
            this.getShareData()
		}
		
    },
    methods: {
        getApplyStatus() {
            for (let i = 1; i < 5; i++) {
                var params = {
					token: this.token,
					type: i
				}
                this.$api.my.roleStatus(params).then(res => {
                    if (res.code == 200) {
                        //res.result 0认证中1认证通过2未通过3未申请
                        if (i == 1) {
                                this.applyTradesman = res.result
                            } else if (i == 2) {
                                this.applySeller = res.result
                            } else if (i == 3) {
                                this.applyAgent = res.result
                            } else if (i == 4) {
                                this.applyPartner = res.result
                            }
                    } else {
                        this.$toast(res.message)
                    }
                })
            }
        },
        goPage(path,type,status) {
			console.log('type',type)
			console.log('status',status)
            this.$router.push({
                path: path,
                query:{
                        type: type,
                        status: status // 0认证中1认证通过2未通过3未申请
                    }
                
            })
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '申请合作', // 分享标题
                    desc: '诚邀匠人免费入驻，资源共享，合作共赢。\n这里也许会成为你独一无二的展示平台和空间……', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.shareImgPath + 'hezuo.jpg', // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
